/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import Menu from '@mui/material/Menu';
import styled from 'styled-components';

const BeamMenu: typeof Menu = styled(Menu)`
    top: -1px;
    
    & .MuiMenu-paper {
        background-color: #1C262F;
        border-radius: 16px;
        border: 1px solid #FAFAFA;
    }
`

export default BeamMenu;